import { z } from 'zod';
import { getPasswordSchema } from '@/app/(auth)/forms/password-schema';

export const RESTAURANT_TYPES = [
  'BISTROT',
  'GASTRONOMIC',
  'WINE_BAR',
  'BRASSERIE',
] as const;

export const RESTAURANT_TYPE_LABELS: Record<
  (typeof RESTAURANT_TYPES)[number],
  string
> = {
  BISTROT: 'Bistrot',
  GASTRONOMIC: 'Gastronomic',
  WINE_BAR: 'Wine Bar',
  BRASSERIE: 'Brasserie',
};

export const getRestaurantSignupSchema = () => {
  return z
    .object({
      restaurantName: z
        .string()
        .min(2, { message: 'Restaurant name must be at least 2 characters long.' }),
      siret: z
        .string()
        .regex(/^\d{14}$/, { message: 'SIRET must be exactly 14 digits.' }),
      city: z.string().min(2, { message: 'City is required.' }),
      address: z.string().min(2, { message: 'Address is required.' }),
      type: z.enum(RESTAURANT_TYPES, {
        errorMap: () => ({ message: 'Please select a restaurant type.' }),
      }),
      email: z
        .string()
        .email({ message: 'Please enter a valid email address.' }),
      password: getPasswordSchema(),
      passwordConfirmation: z.string().min(1, {
        message: 'Password confirmation is required.',
      }),
    })
    .refine((data) => data.password === data.passwordConfirmation, {
      message: 'Passwords do not match.',
      path: ['passwordConfirmation'],
    });
};

export type RestaurantSignupSchemaType = z.infer<
  ReturnType<typeof getRestaurantSignupSchema>
>;
